module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    attrs: {
      "type": "file",
      "id": 'imageUpload-' + _vm.carForSaleID,
      "name": "imageName",
      "multiple": ""
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.imageLists), function(imageList) {
    return _c('div', {
      staticClass: "col-xs-6 col-md-3"
    }, [_c('div', {
      staticClass: "thumbnail"
    }, [_c('img', {
      attrs: {
        "src": _vm.$http.options.root + _vm.imageFolderPath + imageList.name,
        "alt": "Imagen",
        "height": "120",
        "width": "120"
      }
    }), _c('br'), _vm._v(" "), _c('label', [_c('span', {
      staticStyle: {
        "font-size": "2em"
      }
    }, [_vm._v("                                                  \n                      "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (imageList.priority == 1),
        expression: "imageList.priority == 1"
      }],
      staticClass: "glyphicon glyphicon-asterisk",
      staticStyle: {
        "color": "#4db8ff"
      },
      attrs: {
        "title": "Foto Principal"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (imageList.priority != 1),
        expression: "imageList.priority != 1"
      }],
      staticClass: "glyphicon glyphicon-ok",
      staticStyle: {
        "color": "#39e600"
      },
      attrs: {
        "title": "Poner como foto principal"
      },
      on: {
        "click": function($event) {
          return _vm.putPrincipalImage(imageList)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "glyphicon glyphicon-remove",
      staticStyle: {
        "color": "#ff471a"
      },
      attrs: {
        "title": "Borrar"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImage(imageList)
        }
      }
    })])])])])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b505c26", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b505c26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageUpload.vue
// module id = 110
// module chunks = 0